import * as React from 'react';

import {useGetFilteredCompaniesListUrlPath} from '../visitors/companies-list/use-get-filtered-companies-list-url-path';
import {CompaniesMapWrapper} from '../visitors/companies-map/companies-map-wrapper';
import {IndustriesWrapper} from '../visitors/industries/industries-wrapper';
import {useGetTopTenReport} from '../visitors/summary/use-get-top-ten-report';

export function VisitorsSummary() {
    const getFilteredListUrlPath = useGetFilteredCompaniesListUrlPath();

    const {
        topTenReport: statesReport,
        isLoading: statesLoading,
        isError: statesError,
    } = useGetTopTenReport('state');

    const {
        topTenReport: industriesReport,
        isLoading: industriesLoading,
        isError: industriesError,
    } = useGetTopTenReport('industryCodePrefix');

    return (
        <>
            <CompaniesMapWrapper
                topTenReport={statesReport}
                isLoading={statesLoading}
                isError={Boolean(statesError)}
                getFilteredListUrlPath={getFilteredListUrlPath}
            />
            <IndustriesWrapper
                industriesReport={industriesReport}
                isLoading={industriesLoading}
                isError={Boolean(industriesError)}
                getFilteredListUrlPath={getFilteredListUrlPath}
            />
        </>
    );
}
